import React from 'react'
import { FieldRenderProps } from 'react-final-form'

import showRealtimeError from '@cinch/oxd-components/error/src/show-realtime-error'
import Text, { TextStyles } from '@cinch/oxd-components/text/src'

import * as styles from './error.module.css'

const defaultMeta = {
  touched: false,
  error: '',
  submitError: '',
  dirtySinceLastSubmit: false,
  submitting: false,
}

interface ErrorProps extends FieldRenderProps {
  showCondition?: (meta: FieldRenderProps['meta']) => boolean
}

const Error: React.FC<Pick<ErrorProps, 'meta' | 'showCondition'>> = ({
  meta = defaultMeta,
  showCondition = showRealtimeError,
}) => {
  const hasError = showCondition(meta)
  const errorMessage = meta.error || meta.submitError

  return (
    <Text role={hasError ? 'alert' : 'presentation'} type={TextStyles.caption} element="div" className={styles.error}>
      {hasError && errorMessage}
    </Text>
  )
}

export default Error
